export const REQUEST_TYPES = {
  ROB_REQUEST: 'ROB_REQUEST',
  ROB_REPLACEMENT_VEHICLE: 'ROB_REPLACEMENT_VEHICLE',
};

export const IsReplacementVehicle = (request_type) => {
  return request_type === REQUEST_TYPES.ROB_REPLACEMENT_VEHICLE;
};
